export default {
  app: {
    tradeOffers: {
      country: 'Страна',
      loginPrompt: 'Чтобы увидеть предложения, необходимо {0}.',
      logIn: 'войти',
    },
  },
};
